import { SxProps, Theme } from '@mui/system';
import classNames from 'classnames';
import { ReactNode } from 'react';
import CloseButton from './CloseButton';
import ModalCard from './ModalCard';

interface IProps {
  handleClose: () => void;
  titleIcon?: string | ReactNode;
  title?: string;
  titleClassname?: string;
  titleId?: string;
  sx?: SxProps<Theme>;
  subtitle?: string | ReactNode;
}

const ModalTitleCard = ({
  handleClose,
  titleIcon,
  title,
  titleClassname = 'mb-1',
  titleId = 'modal-title',
  subtitle,
  sx,
}: IProps) => {
  return (
    <ModalCard
      sx={{
        borderRadius: '12px',
        gap: '25px',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        padding: '20px',
        ...sx,
      }}
    >
      <div className='icon-section'>{titleIcon}</div>
      <div>
        <h2 className={classNames('font-semibold text-[24px]', 'modal-title', titleClassname)} id={titleId}>
          {title}
        </h2>
        <span className='text-[#84818A] text-[14px] modal-subtitle'>{subtitle}</span>
      </div>
      <div className='absolute right-[16px] top-[16px]'>
        <CloseButton onClick={handleClose} />
      </div>
    </ModalCard>
  );
};

export default ModalTitleCard;
